export const modeTheme = {
  /* =========================
     DISPLAY MODES
  ========================= */

  home: {
    primary: "#2F6EA3"
  },

  business: {
    primary: "#4A4A4A"
  },

  edu: {
    primary: "#E86A1F"
  },

  nightstand: {
    primary: "#C6C6D1"
  },

  classroom: {
    primary: "#568203"
  },

  /* =========================
     OTHER PLATFORMS
  ========================= */

  church: {
    primary: "#8FAF7D"
  },

  admin: {
    primary: "#6D8196"
  },

  campus: {
    primary: "#E86A1F"
  },

  tv: {
    primary: "#8088A0"
  },

  pages: {
    primary: "#F2B705"
  },

  sports: {
    primary: "#7A1F24"
  }
};

/* =========================
   FALLBACK (HOME)
========================= */

export const fallbackTheme = modeTheme.home;
